import { Image } from "@chakra-ui/react"
export const Fcgoogle =()=>{

   return  <Image  src="https://cdn-teams-slug.flaticon.com/google.jpg" w="40px" h="40px"/>
}